module.exports = __webpack_public_path__ + "packs/media/images/palestra-487a31da3d23a20d0fdbe90cdaff77f4.jpg";